import React from "react";
import { Column } from "react-foundation";
import utils from "../utils/index";
import { Link } from "react-router-dom";


const ItemSelectorItem = ({ProductSuites, type, name, to, icon, bgImage, customerColour, columnSize, offset, isMobile, loading, selectedItem, caption}) => (
    !loading && utils.checkProductSuiteExists(type ,ProductSuites) && (
        <Column
            offsetOnMedium={offset}
            medium={columnSize}
            className={
                "item-panel end" +
                (selectedItem === name ? " selected" : "")
            }                    >
            <img src={bgImage} alt="" className="item-selector-thumb"/>
            <div className="text-panel" style={{ backgroundColor: customerColour }}>
                <div className="inner-text-panel">
                    <img className="icon-padding show-for-medium" src={icon} alt="" />
                    <p className="item-selector-text show-for-medium">{caption}</p>
                    <Link 
                        className={'button ' + (isMobile ? 'is-mobile' : '')}
                        to={to}
                        style={{
                            backgroundColor: customerColour,
                            borderColor: customerColour,
                            color: '#fff',
                        }}
                    >
                        <span className="show-for-small-only">Start your quote</span>
                        <span className="show-for-medium">{name}</span>
                    </Link>
                </div>
            </div>
        </Column>
    )
);

export default ItemSelectorItem;


// WEBPACK FOOTER //
// ./src/components/ItemSelectorItem.js